import React, { useContext } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';
import DataContext from '../context/DataContext';


// Initialize modules
exporting(Highcharts);
exportData(Highcharts);

const HighChartPie = ({ chartData, chartName, colors, showLegend = true }) => {
  
const { language } = useContext(DataContext);

  
  const defaultData = [
    { name: 'Public', y: 0 },
    { name: 'Monitors', y: 0 },
    { name: 'Staff', y: 0 },
  ];



  
  const pieOptions = {
    chart: {
      type: 'pie',
    },
    title: {
      text: chartName || 'Incident Sources',
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: true,
    },

    legend: {
      enabled: true, // Show legend
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
    },
    tooltip: {
      pointFormat: '<b>Incidents: {point.y}</b>', // Tooltip on hover
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true, // Show value labels on the pie
          format: showLegend ? language === 'TZ' ? ' Matukio: <b>{point.name}</b>: {point.y} ' : ' <b>{point.name}</b>: {point.y}:Incidents' : '{point.y} incidents',
        },
        showInLegend: true, // Show items in the legend
      },
    },
    colors: colors || ['#41A6D7', '#1E4376', '#E85E3F'],
    series: [
      {
        name: 'Incidents',
        data: chartData && chartData.length > 0 ? chartData : defaultData,
      },
    ],
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={pieOptions}
    />
  );
};

export default HighChartPie;
